import React, { useState } from "react";
import { Typography } from "@mui/material";
import AttendanceCardIcon from "../../asset/svg/AttendanceCardIcon.svg";
import "../../scss/pages/Attendance/Attendance.scss";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  ASSETS_REGISTER_PATH,
  ASSET_SELECT_STORE_PATH,
  ATTENDANCE_VIEWED_CARD_DATA,
  CHECKLIST_PLANNER_PATH,
  LEAVE_VIEWED_CARD_DATA,
  WEEKLY_OFF_PATH,
} from "../../utils/Constants";
import requestEmptyIcon from "../../asset/svg/zeroStateAdmin.svg";
import LeavesCardIcon from "../../asset/svg/LeavesCardIcon.svg";
import WeekOffCardIcon from "../../asset/svg/WeekOffCardIcon.svg";
import AssetsCardIcon from "../../asset/svg/AssetsCardIcon.svg";
import ChecklistIcon from "../../asset/svg/ChecklistIcon.svg";
import { getLocalStoreString } from "../../utils/Helper";

function Admin() {
  const { WriteServicesList } = useSelector(mapStateToProps);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const WriteServices = localStorage.getItem("WriteServices");
  const EmployeeCode = getLocalStoreString("EmployeeCode");

  console.log(WriteServicesList);

  const [cardData, setCardData] = useState([
    {
      name: "Attendance",
      type: "Attendance",
      image: AttendanceCardIcon,
      permission: "attendance_mobile",
    },
    {
      name: "Leave",
      type: "Leave",
      image: LeavesCardIcon,
      permission: "leave_mobile",
    },
    {
      name: "Week Off",
      type: "WeekOff",
      image: WeekOffCardIcon,
      permission: "weeklyoff_mobile",
    },
    // { name: 'Give Rewards', type: 'GiveRewards', image: AttendanceRewardCardIcon }
    {
      name: "Assets",
      type: "Assets",
      image: AssetsCardIcon,
      permission: "assets_mobile",
    },
    {
      name: "Checklist",
      type: "Checklist",
      image: ChecklistIcon,
      permission: "checklist_mobile",
    },
  ]);

  const cardClickToNavigate = (doc) => {
    const { name } = doc;
    switch (name) {
      case "Attendance":
        navigate(ATTENDANCE_VIEWED_CARD_DATA);
        break;
      case "Leave":
        navigate(LEAVE_VIEWED_CARD_DATA);
        break;
      case "Week Off":
        navigate(WEEKLY_OFF_PATH);
        break;
      case "Assets":
        navigate(ASSET_SELECT_STORE_PATH);
        break;
      case "Checklist":
        navigate(CHECKLIST_PLANNER_PATH);
      default:
        break;
    }
  };

  const filteredData = cardData?.filter((item) => {
    if (WriteServices?.includes("all")) {
      return item;
    }
    if (WriteServices?.includes("attendance_mobile")) {
      return WriteServices.includes(item?.permission);
    }
    if (WriteServices?.includes("assets_mobile")) {
      return WriteServices.includes(item?.permission);
    }
    if (WriteServices?.includes("leave_mobile")) {
      return WriteServices.includes(item?.permission);
    }
    if (WriteServices?.includes("weeklyoff_mobile")) {
      return WriteServices.includes(item?.permission);
    }
    if (WriteServices?.includes("checklist_mobile")) {
      return WriteServices.includes(item?.permission);
    }
  });

  return (
    <div className="attendanceContainer">
      <div className="attendanceContainer_header">
        <Typography className="attendanceContainer_header_header1">
          Admin
        </Typography>
      </div>
      {filteredData?.length > 0 ? (
        <div className="attendanceContainer_cardContainer">
          {filteredData?.map((doc) => {
            return (
              <Box
                key={doc.name}
                onClick={() => cardClickToNavigate(doc)}
                sx={{
                  height: "100px",
                  background:
                    "linear-gradient( rgba(255, 255, 255, 0.1) , rgba(255, 255, 255, 0.1) )",
                  padding: "1rem",
                  borderRadius: "12px",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  minWidth: "100px",
                }}
              >
                <div>
                  <Typography
                    color="white"
                    fontWeight={600}
                    fontSize="12px"
                    lineHeight="12px"
                    sx={{ float: "left" }}
                  >
                    {doc?.name}
                  </Typography>
                </div>
                <div>
                  <img
                    className="attendanceContainer_header_attendanceCoinsLogo"
                    src={doc?.image}
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
              </Box>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "10%",
          }}
        >
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              width: "159px",
              height: "159px",
              borderRadius: "200px",
              background: "rgb(222, 225, 255,0.06)",
              alignItems: "center",
            }}
          >
            <img
              style={{ heigth: "54px", width: "68px" }}
              src={requestEmptyIcon}
              alt=""
            />
          </div>
          <div style={{ marginTop: "2rem", textAlign: "center" }}>
            <Typography
              fontStyle="normal"
              fontWeight="400"
              fontSize="16px"
              lineHeight="16px"
              textAlign="center"
              color="rgba(255,255,255,0.8)"
            >
              You don't have admin access
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    WriteServicesList: state.authConfig.WriteServicesList,
  };
};

export default Admin;
